import styled, { css } from 'styled-components'
import { TypeFiesta } from '@at/design-system-foundation'
import { Button } from '@at/design-system-elements'

export const InfoBannerWrapper = styled(TypeFiesta)<{ $disabled?: boolean }>`
    ${({ theme, $disabled }) => css`
        background-color: ${!$disabled ? theme.color.bgFill.highlight : theme.color.bgFill.disabled};
        color: ${!$disabled ? theme.color.text.default : theme.color.text.disabled};
        padding: 16px;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        font-variation-settings: 'wght' 400;
        align-items: start;
        justify-content: center;
        text-align: start;
        margin-bottom: 20px;
    `}
`

export const InfoBannerParagraph = styled.p`
    width: 100%;
    text-align: start;
`

export const ActionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    width: 100%;
    > div {
        width: 100%;
    }
`

export const StyledPostcode = styled.div`
    text-align: start;
`

export const MessageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
`

export const InfoButton = styled(Button)`
    padding: 16px 0;
    background-color: transparent;
    &.info-button {
        &:active,
        &:focus,
        &:hover {
            background-color: transparent;
        }
    }
`
